import React from "react";
import { Row, Col } from "reactstrap";
import { BoldLabel } from "../../../../utils/budget-tool-specific";
import styled from "styled-components";
import { RebelColors } from "../../../../styles/rebel-experiences";

const RebelOutputDiv = styled.div`
    background-color: ${RebelColors.surface};
    border: 1px solid ${RebelColors.border};
    border-radius: 8px;
    padding: 1.5rem;
    margin-top: 0.75rem;
`;

const RebelBoldLabel = styled(BoldLabel)`
    color: ${RebelColors.gold};
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
`;

const RebelTitle = styled.h3`
    color: ${RebelColors.gold};
    font-size: 1.75rem;
    font-weight: 600;
    margin-bottom: 1rem;
`;

const RebelText = styled.p`
    color: ${RebelColors.primary};
    margin-bottom: 0.75rem;
    line-height: 1.6;

    strong {
        color: ${RebelColors.gold};
        font-weight: 600;
    }
`;

const RebelClientOutput = (props) => {

    const { data } = props;

    console.log('Client Output Data:', data);
    console.log('Notes field:', data.notes);

    // Handle notes - it could be a string, an object with .value, or undefined
    const notesText = typeof data.notes === 'string'
        ? data.notes
        : (typeof data.notes?.value === 'string' ? data.notes.value : '');

    return (
        <React.Fragment>
            <Row style={{marginTop: "30px", marginBottom: "50px"}}>
                <Col md="6">
                    <RebelBoldLabel>Rebel Experience Summary</RebelBoldLabel>
                    <RebelOutputDiv>
                        <RebelTitle>{data.title?.value || "Untitled Rebel Experience"}</RebelTitle>
                        <RebelText><strong>Attendees:</strong> {data.attendees?.value}</RebelText>
                        <RebelText><strong>Trip Length:</strong> {data.tripLength?.value} nights / {(data.tripLength?.value || 0) + 1} days</RebelText>
                        <RebelText><strong>Currency:</strong> {data.currency?.value}</RebelText>
                        {notesText && (
                            <RebelText><strong>Notes:</strong> {notesText}</RebelText>
                        )}
                    </RebelOutputDiv>
                </Col>
                <Col md="6">
                    <RebelBoldLabel>Financial Summary</RebelBoldLabel>
                    <RebelOutputDiv>
                        <RebelText><strong>Contingency:</strong> {data.contingency?.value}%</RebelText>
                        {data.overhead?.value && <RebelText><strong>Administrative & Management Fee:</strong> {data.overhead?.value}{data.overheadPercent?.value ? '%' : ''}</RebelText>}
                        {data.margin?.value && <RebelText><strong>Planning Fee:</strong> {data.marginPercent?.value ? `${data.margin?.value}%` : `${data.currency?.value?.slice(3) || '$'}${data.margin?.value} per person`}</RebelText>}
                    </RebelOutputDiv>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default RebelClientOutput;